import { PanelSection, Table } from '@dev-spendesk/grapes';
import classNames from 'classnames';

import { useTranslation } from 'common/hooks/useTranslation';
import { CopyableText } from 'src/core/common/components/CopyableText';
import { COUNTRIES } from 'src/core/config/country';

type Props = {
  companyName: string;
  address: string;
  address2?: string;
  city: string;
  zipCode: string;
  countryKey: string;
  companyVat?: string;
  showSubtitle?: boolean;
};

export const BillingAddress = ({
  address,
  address2,
  city,
  companyName,
  countryKey,
  zipCode,
  companyVat,
  showSubtitle,
}: Props) => {
  const { t } = useTranslation('global');

  const country = COUNTRIES[countryKey?.toUpperCase()];

  return (
    <PanelSection>
      <div className={classNames(!showSubtitle ? 'mb-16' : '', 'title-l')}>
        {t('card.billingAddress')}
      </div>
      {showSubtitle && (
        <div className="mb-12 text-content-secondary-bg-primary">
          {t('card.billingAddressSubtitle')}
        </div>
      )}
      <Table.Mini
        className="bg-background-primary-default"
        columns={[
          {
            id: 'label',
            width: '120px',
            renderCell: (cell) => (
              <span className="text-content-secondary-bg-primary">{cell.label}</span>
            ),
          },
          {
            id: 'value',
            renderCell: (cell) => (
              <CopyableText value={cell.value} className="-mx-16" />
            ),
          },
        ]}
        data={[
          {
            id: 0,
            label: t('misc.name'),
            value: companyName,
          },
          {
            id: 1,
            label: t('misc.address'),
            value: address,
          },
          ...(address2
            ? [
                {
                  id: 2,
                  label: t('generalSettings.address.address2Label'),
                  value: address2,
                },
              ]
            : []),
          {
            id: 3,
            label: t('generalSettings.address.zipcodeLabel'),
            value: zipCode,
          },
          {
            id: 4,
            label: t('generalSettings.address.cityLabel'),
            value: city,
          },
          ...(country
            ? [
                {
                  id: 5,
                  label: t('generalSettings.address.countryLabel'),
                  value: country ? t(country.translationKey) : '',
                },
              ]
            : []),
          ...(companyVat
            ? [
                {
                  id: 6,
                  label: t('card.vatNumber'),
                  value: companyVat,
                },
              ]
            : []),
        ]}
        getRowId={(row) => String(row.id)}
      />
    </PanelSection>
  );
};
